import { BorderedContainer } from 'core/components/common/BorderedContainer';
import { IncidentDetailPatientForSendai } from 'sections/sendai/features/useIncidentDetailForSendai';
import { SectionTitle } from 'core/components/common/SectionTitle';
import { PdfItem } from 'core/components/JianDetail/PatientDetailInfo/ActivityRecordPdf/PdfItem';
import { DataNotFound } from 'core/components/common/DataNotFound';
import { FC } from 'react';

type Props = {
  activityRecordPdf: IncidentDetailPatientForSendai['activityRecordPdf'];
  emsReportPdf: IncidentDetailPatientForSendai['emsReportPdf'];
};

export const DocumentsView: FC<Props> = ({
  activityRecordPdf,
  emsReportPdf,
}) => {
  return (
    // BorderedContainer 間でマージンを取る
    <div className="flex flex-col gap-[24px]">
      <BorderedContainer>
        <div className="flex flex-col gap-[24px]">
          <SectionTitle text="救命カードPDF" />
          {activityRecordPdf.length > 0 ? (
            activityRecordPdf.map(pdf => (
              <PdfItem key={pdf.documentId} pdf={pdf} />
            ))
          ) : (
            <DataNotFound msg="救命カードは作成されていません" />
          )}
        </div>
      </BorderedContainer>
      <BorderedContainer>
        <div className="flex flex-col gap-[24px]">
          <SectionTitle text="救急記録表PDF" />
          {emsReportPdf.length > 0 ? (
            emsReportPdf.map(pdf => <PdfItem key={pdf.documentId} pdf={pdf} />)
          ) : (
            <DataNotFound msg="救急記録表は作成されていません" />
          )}
        </div>
      </BorderedContainer>
    </div>
  );
};
